"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _formatRankingScoreByType = _interopRequireDefault(require("./formatRankingScoreByType"));

var _user = _interopRequireDefault(require("../user"));

var _char = _interopRequireDefault(require("../char"));

var formatNameItem = function formatNameItem(_ref) {
  var isActiveUser = _ref.isActiveUser,
      firstName = _ref.firstName,
      lastName = _ref.lastName,
      t = _ref.t;

  if (!isActiveUser) {
    return t('ds-rankings.deleted.user');
  }

  if (firstName || lastName) {
    return "".concat(_char["default"].capitalizeWords(firstName), " ").concat(_char["default"].capitalizeWords(lastName));
  }

  return t('ds-users.no_name_user');
};

var formatLeaderboardItem = function formatLeaderboardItem(_ref2) {
  var rankingType = _ref2.rankingType,
      item = _ref2.item,
      t = _ref2.t,
      unit = _ref2.unit,
      sport = _ref2.sport,
      calculationMethod = _ref2.calculationMethod,
      _ref2$measurementSyst = _ref2.measurementSystem,
      measurementSystem = _ref2$measurementSyst === void 0 ? 'metric' : _ref2$measurementSyst,
      locale = _ref2.locale,
      _ref2$durationUnit = _ref2.durationUnit,
      durationUnit = _ref2$durationUnit === void 0 ? 'seconds' : _ref2$durationUnit;
  var finalUnit = "".concat(unit).concat(calculationMethod === 'total' ? '' : calculationMethod);

  if (rankingType === 'groups') {
    var _item$membersCount = item.membersCount;
    _item$membersCount = _item$membersCount === void 0 ? {} : _item$membersCount;
    var totalMembersGroup = _item$membersCount.score,
        _item$group = item.group;
    _item$group = _item$group === void 0 ? {} : _item$group;
    var _id2 = _item$group._id,
        _item$group$name = _item$group.name,
        nameGroup = _item$group$name === void 0 ? '' : _item$group$name,
        _item$group$display = _item$group.display;
    _item$group$display = _item$group$display === void 0 ? {} : _item$group$display;
    var logoGroup = _item$group$display.logo,
        emoji = _item$group$display.emoji,
        emojiBackgroundColor = _item$group$display.color,
        parent = _item$group.parent;

    var _ref3 = item[finalUnit] || {},
        rankGroup = _ref3.rank,
        scoreGroup = _ref3.score,
        progressionGroup = _ref3.progression;

    return {
      rank: rankGroup,
      initials: nameGroup.substring(0, 2).toUpperCase(),
      name: nameGroup,
      score: (0, _formatRankingScoreByType["default"])({
        score: scoreGroup,
        unit: unit,
        measurementSystem: measurementSystem,
        sport: sport,
        locale: locale,
        durationUnit: durationUnit
      }),
      picture: logoGroup,
      emoji: emoji,
      emojiBackgroundColor: emojiBackgroundColor,
      progression: progressionGroup,
      totalMembersGroup: totalMembersGroup,
      _id: _id2,
      parent: parent
    };
  }

  var _item$user = item.user;
  _item$user = _item$user === void 0 ? {} : _item$user;
  var firstName = _item$user.firstName,
      lastName = _item$user.lastName,
      picture = _item$user.picture,
      _id = _item$user._id,
      _item$user$groups = _item$user.groups;
  _item$user$groups = _item$user$groups === void 0 ? [] : _item$user$groups;

  var _item$user$groups2 = (0, _slicedToArray2["default"])(_item$user$groups, 1),
      _item$user$groups2$ = _item$user$groups2[0];

  _item$user$groups2$ = _item$user$groups2$ === void 0 ? {} : _item$user$groups2$;
  var _item$user$groups2$$r = _item$user$groups2$.rank,
      teamUserRank = _item$user$groups2$$r === void 0 ? '' : _item$user$groups2$$r,
      userStatuses = _item$user.userStatuses;

  var _ref4 = item[unit] || {},
      scoreUser = _ref4.score,
      rankUser = _ref4.rank,
      progressionUser = _ref4.progression;

  var isActiveUser = _user["default"].isActiveUser(item.user);

  return {
    rank: rankUser,
    initials: _user["default"].getInitials(firstName, lastName),
    name: formatNameItem({
      isActiveUser: isActiveUser,
      firstName: firstName,
      lastName: lastName,
      t: t
    }),
    score: (0, _formatRankingScoreByType["default"])({
      score: scoreUser,
      unit: unit,
      measurementSystem: measurementSystem,
      sport: sport,
      locale: locale,
      durationUnit: durationUnit
    }),
    picture: picture,
    progression: progressionUser,
    _id: _id,
    isActiveUser: isActiveUser,
    teamUserRank: teamUserRank,
    userStatuses: userStatuses
  };
};

var _default = formatLeaderboardItem;
exports["default"] = _default;
//# sourceMappingURL=formatLeaderboardItem.js.map